/* eslint-disable no-bitwise */
/**
 * When we place the moov atom before the mdat atom, we need to update the stco
 * chunk offsets to reflect that the moov atom's length is now before these
 * chunks. That's what this function does.
 *
 * @param rawStco The binary data for the stco atom
 * @param atomLength The length of the atom that we need to adjust chunk offsets by
 */
export const handleRawStco = (rawStco, atomLength) => {
  const numOfEntries = (rawStco[12] << 24) + (rawStco[13] << 16) + (rawStco[14] << 8) + rawStco[15];
  for (let entryNumber = 0; entryNumber < numOfEntries; entryNumber++) {
    const valOffset = entryNumber * 4 + 16;

    const chunkOffset =
      (rawStco[valOffset] << 24) +
      (rawStco[valOffset + 1] << 16) +
      (rawStco[valOffset + 2] << 8) +
      rawStco[valOffset + 3] +
      atomLength;

    rawStco[valOffset] = (chunkOffset & 0xff000000) >> 24;
    rawStco[valOffset + 1] = (chunkOffset & 0x00ff0000) >> 16;
    rawStco[valOffset + 2] = (chunkOffset & 0x0000ff00) >> 8;
    rawStco[valOffset + 3] = chunkOffset & 0x000000ff;
  }
};

export const handleRawCo64 = (rawCo64, atomLength) => {
  const numOfEntries = (rawCo64[12] << 24) + (rawCo64[13] << 16) + (rawCo64[14] << 8) + rawCo64[15];
  for (let entryNumber = 0; entryNumber < numOfEntries; entryNumber++) {
    const valOffset = entryNumber * 8 + 16;
    const chunkOffset =
      // Intentionally ignoring the upper 16 bits as it would overflow in standard
      // JS and is only required to support videos over 280TB
      (rawCo64[valOffset + 2] << 40) +
      (rawCo64[valOffset + 3] << 32) +
      (rawCo64[valOffset + 4] << 24) +
      (rawCo64[valOffset + 5] << 16) +
      (rawCo64[valOffset + 6] << 8) +
      rawCo64[valOffset + 7] +
      atomLength;

    // Intentionally ignoring the upper 16 bits as it would overflow in standard JS and
    // is only required to support videos over 280TB
    rawCo64[valOffset + 2] = (chunkOffset & 0xff0000000000) >> 40;
    rawCo64[valOffset + 3] = (chunkOffset & 0xff00000000) >> 32;
    rawCo64[valOffset + 4] = (chunkOffset & 0xff000000) >> 24;
    rawCo64[valOffset + 5] = (chunkOffset & 0x00ff0000) >> 16;
    rawCo64[valOffset + 6] = (chunkOffset & 0x0000ff00) >> 8;
    rawCo64[valOffset + 7] = chunkOffset & 0x000000ff;
  }
};
